import { Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription} from 'rxjs';
import { User } from 'src/app/models/user';
import { LoaderService } from 'src/app/services/loader.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit, OnDestroy{
  activeTab: string = 'withRating'; // Default active tab
  personalDetails: User = new User();
  private subscription: Subscription;

  constructor(private userService: UserService, private loaderService: LoaderService){}
  ngOnInit(){
    this.loaderService.setLoading(true);
    this.subscription = this.userService.getById(`/api/tenants/myProfile`).subscribe((response : any) => {
    this.personalDetails.firstName = response.user.firstname;
    this.personalDetails.lastName = response.user.lastname;
    this.personalDetails.email = response.user.email;
    this.personalDetails.address = response.address1;
    this.personalDetails.city = response.city;
    this.personalDetails.zip = response.zip;
    this.personalDetails.mobileNumber = response.phoneNumber;
    // Location: "",
    this.personalDetails.instagramId = response.instagramId;
    this.personalDetails.tikTokId = response.tikTokId;
    this.personalDetails.faceBookId = response.facebookId;
    this.personalDetails.profilePicture = response.user.photo;
    if(response.user.photo){
      this.userService.getUserImage(`/api/tenants/me/retriveImage?name=`, response.user.photo).subscribe((response:any)=>{
        this.personalDetails.profilePictureUrl = response;
        this.userService.setProfilePictureUrl(response);
        this.loaderService.setLoading(false);
    });
     }else{
      this.loaderService.setLoading(false);
     }
  });
  }

  showWithRating(event: Event) {
    event.preventDefault();
    this.activeTab = 'withRating';
  }
  showNew(event: Event) {
    event.preventDefault();
    this.activeTab = 'new';
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
